(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea10d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea10d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bUMk2", function(module, exports) {

var $99FLw = parcelRequire("99FLw");

var $38e4d = parcelRequire("38e4d");

var $ff14C = parcelRequire("ff14C");

var $5yjqu = parcelRequire("5yjqu");

var $9iny5 = parcelRequire("9iny5");
const layoutUpdater = new (0, $38e4d.default)();
$(document).ready(function() {
    const layoutBuilder = new (0, $99FLw.default)();
    layoutBuilder.build();
    layoutUpdater.update();
});
$(document).ajaxComplete(function() {
    layoutUpdater.update();
});
$(window).load(()=>{
    eval(`hbspt.forms.create({ region: 'na1', portalId: '5246303', formId: '53013292-7d70-4628-a81b-48eed91cced5' })`);
    window.addEventListener("message", (event)=>{
        if (event.data.type === "hsFormCallback" && event.data.eventName === "onFormReady") {
            (0, $ff14C.default).inject();
            if (ENABLE_STAT_COLLECTING) (0, $5yjqu.default).inject();
            (0, $9iny5.default).inject();
            const currentTheme = localStorage.getItem("rapydDocsTheme") || "light";
            $(document.querySelector("iframe.hs-form-iframe")).contents().find("html").attr("data-theme", currentTheme);
        }
    });
});

});
parcelRegister("99FLw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6aa55a156f4a44cc$export$2e2bcd8739ae039; });

var $34u9k = parcelRequire("34u9k");

var $1FoK2 = parcelRequire("1FoK2");

var $eMLUv = parcelRequire("eMLUv");

var $lWyyq = parcelRequire("lWyyq");

var $7zAu3 = parcelRequire("7zAu3");

var $49gYd = parcelRequire("49gYd");

var $4v18O = parcelRequire("4v18O");

var $gzpGe = parcelRequire("gzpGe");
class $6aa55a156f4a44cc$export$2e2bcd8739ae039 {
    constructor(){
        this.header = $(".navbar-header");
        this.siteBody = $(".site-body-row");
        this.search = $(".site-sidebar-search");
        this.document = $(document);
    }
    build() {
        this._injectTemplates();
        this._initializePermanentContent();
        this._listenOnPermanentEvents();
    }
    _injectTemplates() {
        //inject search to header
        this.header.append((0, $lWyyq.default));
        this.header.append((0, $7zAu3.default));
        // reinitialize Paligo search engine
        this.document.trigger("search.ready");
        // inject login button to header
        this.header.append((0, $49gYd.default));
        // inject theme switcher button to header
        this.header.append((0, $4v18O.default));
        //inject footer
        this.siteBody.append((0, $gzpGe.default));
    }
    _initializePermanentContent() {
        this.themeSwitcher = new (0, $34u9k.default)();
        this.search = typeof algoliasearch === "function" ? new (0, $1FoK2.default)() : new (0, $eMLUv.default)();
        // rename home navigation item in the left menu
        $(`.site-sidebar .nav-site-sidebar > li > a:contains('Home')`).text("Docs Home");
    }
    _listenOnPermanentEvents() {
        this.themeSwitcher.listenEvents();
        this.search.listenEvents();
    }
}

});
parcelRegister("34u9k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23c921e562f89e70$export$2e2bcd8739ae039; });
class $23c921e562f89e70$export$2e2bcd8739ae039 {
    constructor(){
        this.swhitcher = $(".theme-switcher");
    }
    listenEvents() {
        this.swhitcher.on("click", function() {
            const newTheme = $(document.documentElement).attr("data-theme") === "dark" ? "light" : "dark";
            $(document.documentElement).attr("data-theme", newTheme);
            $(document.querySelector("iframe.hs-form-iframe")).contents().find("html").attr("data-theme", newTheme);
            localStorage.setItem("rapydDocsTheme", newTheme);
        });
    }
    stopListening() {
        this.swhitcher.off("click");
    }
}

});

parcelRegister("1FoK2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $136ccfea14796280$export$2e2bcd8739ae039; });

var $b4VQN = parcelRequire("b4VQN");

var $2J8js = parcelRequire("2J8js");
class $136ccfea14796280$export$2e2bcd8739ae039 {
    constructor(){
        this._initAlgoliaIndex();
        this.searchSidebarForm = $(".site-sidebar-search");
        this._reInitSidebarSearch();
    }
    listenEvents() {
        this._listenInputEventsForAlgoliaSearch();
    }
    _listenInputEventsForAlgoliaSearch() {
        if (typeof algoliasearch !== "function") return;
        this._initAlgoliaSearch();
    }
    _initAlgoliaLibraries() {
        const { autocomplete: autocomplete } = window["@algolia/autocomplete-js"];
        const emptyContainer = document.createElement("div");
        autocomplete({
            container: emptyContainer
        });
    }
    _initAlgoliaIndex() {
        const algoliaClient = algoliasearch(algolia_application_id, algolia_search_only_api_key);
        this.algoliaIndex = algoliaClient.initIndex(publication_id);
        this.QuerySuggestionindex = algoliaClient.initIndex(`QS-index`);
        this.resultsInPage = 10;
    }
    _reInitSidebarSearch() {
        const $sideBar = $(".site-sidebar");
        const $sideBarInput = $(".site-sidebar-search input");
        const $sideBarSearch = $(".site-sidebar-search");
        this.searchSidebarForm.remove();
        this.searchSidebarForm.prependTo($sideBar);
        $sideBarSearch.prepend('<span class="icon-search"></span>');
        $sideBarSearch.append('<span class="icon-delete"></span>');
        $sideBarInput.attr("id", "side-search-bar");
        $sideBarInput.attr("placeholder", "Search Rapyd Docs");
        $sideBarInput.attr("maxlength", 30);
        $sideBar.prepend((0, $b4VQN.default));
    }
    _sortHits(hits) {
        this.categorizedResults = {};
        Object.keys(this.categories).forEach((categoryKey)=>this.categorizedResults[categoryKey] = []);
        hits.forEach((hit)=>{
            Object.keys(this.categorizedResults).forEach((categoryKey)=>{
                if (hit.category?.includes(this.categories[categoryKey].name)) this.categorizedResults[categoryKey].push(hit);
            });
            this.categorizedResults.ALL.push(hit);
        });
    }
    _assignIconToHit(category) {
        switch(category){
            case "REF":
                this.icon = "icon-developers";
                break;
            case "GUIDE":
                this.icon = "icon-book";
                break;
            case "CP":
                this.icon = "icon-plugin";
                break;
            default:
                this.icon = "icon-doc";
                break;
        }
    }
    _disableButton(button) {
        button.classList.add("disabled");
        button.setAttribute("disabled", true);
    }
    _openRecentAndPopularSearchesModal(popularSearchResults) {
        const recentSearchesScript = (0, $2J8js.default).createScriptsAndAppend();
        const searchThis = this;
        const $searchResults = $(".search-results");
        const recentSearches = JSON.parse(localStorage.getItem("last_searches")) || [];
        recentSearchesScript.addEventListener("load", function() {
            searchThis._initAlgoliaLibraries();
        });
        $searchResults.empty();
        if (recentSearches.length > 0) {
            $searchResults.append(`<span class="search-results-headline">RECENT</span>`);
            recentSearches.forEach((hit, index)=>{
                if (searchThis.isSideSearch && index > 1) return;
                this._appendResultForRecent($searchResults, hit);
            });
            $searchResults.append(`<hr class="search-results-separating-line recent">`);
        }
        $searchResults.append(`<span class="search-results-headline">POPULAR SEARCHES</span>`);
        if (popularSearchResults.length > 0) popularSearchResults.forEach((search, index)=>{
            if (searchThis.isSideSearch && index > 1) return;
            if (index > 3) return;
            this._appendResultForPopular($searchResults, search);
        });
        this._openSearchDropdown();
    }
    _enableButton(button) {
        button.classList.remove("disabled");
        button.removeAttribute("disabled");
    }
    _handlePageButtonsStatus() {
        const paginationNumbers = document.body.querySelectorAll(".pagination-number");
        const prev = document.body.querySelector(".pagination-button-prev");
        const next = document.body.querySelector(".pagination-button-next");
        const pageCount = paginationNumbers[paginationNumbers.length - 1].innerHTML;
        if (this.currentPage === 1) this._disableButton(prev);
        else this._enableButton(prev);
        if (Number(pageCount) === this.currentPage) this._disableButton(next);
        else this._enableButton(next);
    }
    _setPageToPrev() {
        this.currentPage = this.currentPage - 1;
        this._allResultModalDisplayPagination();
    }
    _setPageToNext() {
        this.currentPage = this.currentPage + 1;
        this._allResultModalDisplayPagination();
    }
    _getNextResultsPagination() {
        const startIndex = (this.currentPage - 1) * this.resultsInPage;
        const endIndex = startIndex + this.resultsInPage;
        this.allReaultsDisplayData = this.categorizedResults[this.pickedCategory].slice(startIndex, endIndex);
    }
    _getNextResultsInfiniteScroll() {
        const $searchResults = $(".search-results-all");
        this.currentPage = this.currentPage + 1;
        const startIndex = (this.currentPage - 1) * this.resultsInPage;
        const endIndex = startIndex + this.resultsInPage;
        const currentDataToDisplay = this.categorizedResults[this.pickedCategory].slice(startIndex, endIndex);
        currentDataToDisplay.forEach((hit)=>{
            this._assignIconToHit(this.pickedCategory);
            this._appendResultForAllResults($searchResults, hit);
            $searchResults.append(`<div class="result-separator"/>`);
        });
    }
    _getInitialResultsInfiniteScroll() {
        const $searchResults = $(".search-results-all");
        const currentDataToDisplay = this.categorizedResults[this.pickedCategory].slice(0, this.resultsInPage);
        currentDataToDisplay.forEach((hit)=>{
            this._assignIconToHit(this.pickedCategory);
            this._appendResultForAllResults($searchResults, hit);
            $searchResults.append(`<div class="result-separator"/>`);
        });
    }
    _handleActivePageNumber() {
        const paginationNumbers = document.body.querySelectorAll(".pagination-number");
        paginationNumbers.forEach((button)=>{
            button.classList.remove("active");
            const pageIndex = Number(button.getAttribute("page-index"));
            if (pageIndex === this.currentPage) button.classList.add("active");
        });
        this._getNextResultsPagination();
    }
    _appendPageNumber(index) {
        const $paginationNumbers = $(".pagination-numbers");
        const pageNumber = document.createElement("button");
        const searchThis = this;
        pageNumber.className = "pagination-number";
        pageNumber.innerHTML = index;
        pageNumber.setAttribute("page-index", index);
        pageNumber.setAttribute("aria-label", "Page " + index);
        pageNumber.addEventListener("click", function(event) {
            event.preventDefault();
            searchThis.currentPage = index;
            searchThis._allResultModalDisplayPagination();
        });
        $paginationNumbers[0].appendChild(pageNumber);
    }
    _appendDotsForPagination() {
        const $paginationNumbers = $(".pagination-numbers");
        const pageDots = document.createElement("span");
        pageDots.innerHTML = "...";
        pageDots.className = "pagination-dots";
        $paginationNumbers[0].appendChild(pageDots);
    }
    _createPagination(numberOfHits, nbPages) {
        if (nbPages <= this.resultsInPage) for(let i = 1; i <= nbPages; i++)this._appendPageNumber(i);
        else {
            this._appendPageNumber(1);
            if (this.currentPage > 3) this._appendDotsForPagination();
            if (this.currentPage === this.resultsInPage) this._appendPageNumber(this.currentPage - 2);
            if (this.currentPage > 2) this._appendPageNumber(this.currentPage - 1);
            if (this.currentPage !== 1 && this.currentPage !== nbPages) this._appendPageNumber(this.currentPage);
            if (this.currentPage < nbPages - 1) this._appendPageNumber(this.currentPage + 1);
            if (this.currentPage === 1) this._appendPageNumber(this.currentPage + 2);
            if (this.currentPage < nbPages - 2) this._appendDotsForPagination();
            this._appendPageNumber(nbPages);
        }
    }
    _createBreadcrumbs(breadcrumbs) {
        const breadcrumbsArr = breadcrumbs.split("/");
        const breadcrumbsItem = document.createElement("div");
        breadcrumbsItem.className = "breadcrumbs-container";
        breadcrumbsArr.map((item, index)=>{
            const breadcrumb = document.createElement("span");
            breadcrumb.innerText = item || "";
            breadcrumb.className = "breadcrumb-text";
            if (index === breadcrumbsArr.length - 1) breadcrumb.classList.add("mark");
            breadcrumbsItem.appendChild(breadcrumb);
            if (index < breadcrumbsArr.length - 1) {
                const breadcrumbIcon = document.createElement("div");
                breadcrumbIcon.className = "icon icon-chevron_right";
                breadcrumbsItem.appendChild(breadcrumbIcon);
            }
        });
        return breadcrumbsItem.innerHTML;
    }
    _addResultsToRecentSearches(item) {
        if (!localStorage.getItem("last_searches")) localStorage.setItem("last_searches", JSON.stringify([]));
        const localStorageSearches = JSON.parse(localStorage.getItem("last_searches"));
        const unique = localStorageSearches.filter(({ url: url })=>item.url !== url);
        unique.unshift(item);
        const sliced = unique.slice(0, 4);
        localStorage.setItem("last_searches", JSON.stringify(sliced));
    }
    _appendResult(appendTo, hit) {
        const bodyIsJSON = [
            "{",
            "}"
        ].some((el)=>hit._highlightResult.body.value.includes(el));
        appendTo.append(`
                    <a class="search-result-container" href=${hit.url} target="_self">
                        <div  class="search-result-data">
                          <div class="search-result-icon icon ${this.icon}"/>
                          <div>
                              <div class="search-result-title">
                                  ${hit._highlightResult.title.value || (bodyIsJSON ? "Code Sample" : "")}
                              </div>
                              <div class="search-result-breadcrumbs">${this._createBreadcrumbs(hit.breadcrumbs)}</div>
                            </div>
                        </div>
                      </a>
                   `);
    }
    _appendResultForAllResults(appendTo, hit) {
        const bodyIsJSON = [
            "{",
            "}"
        ].some((el)=>hit.body.includes(el));
        appendTo.append(`
                      <a class="search-result-container all" href=${hit.url} target="_self">
                        <div  class="search-result-data all">
                          <div class="all-results-title-container">
                            <div class="search-result-icon icon ${this.icon} all"/>
                             <div class="search-result-title all">
                                 ${hit._highlightResult.title.value || (bodyIsJSON ? "Code Sample" : "")}
                             </div>
                           </div>
                           ${this.isSideSearch ? "" : `<div class="search-result-body all"> ${bodyIsJSON ? hit.url : hit._highlightResult.body.value}</div>`}
                           <div class="search-result-breadcrumbs all">${this._createBreadcrumbs(hit.breadcrumbs)}</div>
                         </div>
                      </a>
                   `);
    }
    _appendResultForRecent(appendTo, hit) {
        const iconClasses = Object.values(hit.icon).reduce((a, currentValue)=>a + " " + currentValue, "");
        appendTo.append(`
                     <a class="search-result-container recent" href="${hit.url}" target="_self">
                       <div class="search-result-data recent">
                            <div class="${iconClasses} recent"/>
                            <div class="title-breadcrumbs-container recent">
                                <div class="search-result-title recent">
                                    ${hit.title}
                                </div>
                                <div class="search-result-breadcrumbs recent">
                                    ${hit.breadcrumbs}
                                </div>
                            </div>
                         </div>
                       </a>
                   `);
    }
    _appendResultForPopular(appendTo, search) {
        appendTo.append(`
                       <div class="search-result-data popular">
                           <span class="search-result-icon icon icon-timer" /> 
                           <div class="search-result-title popular">
                               ${search.query}
                           </div>
                       </div>
                   `);
    }
    _initPickedCategory() {
        let found = false;
        Object.keys(this.categorizedResults).reverse().forEach((key)=>{
            if (this.categorizedResults[key].length > 0) {
                this.pickedCategory = key;
                found = true;
            }
        });
        if (!found) this.pickedCategory = "";
    }
    _displayAllResultPagination() {
        const $searchResults = $(".search-results-all");
        $searchResults.empty();
        this._handleActiveCategory();
        this._allResultModalFooterPagination();
        if (this.allReaultsDisplayData.length > 0) this.allReaultsDisplayData.forEach((hit, hitIndex)=>{
            this._assignIconToHit(this.pickedCategory);
            this._appendResultForAllResults($searchResults, hit);
            if (hitIndex < this.allReaultsDisplayData.length - 1) $searchResults.append(`<div class="result-separator"/>`);
        });
    }
    _displayAllResultInfiniteScroll() {
        const $searchResults = $(".search-results-all");
        $searchResults.empty();
        this._handleActiveCategory();
        this._getInitialResultsInfiniteScroll();
        this._allResultModalFooterInfiniteScroll();
    }
    _allResultModalFooterPagination() {
        const $pagination = $(".pagination-container");
        const searchThis = this;
        const nbHits = this.categorizedResults[this.pickedCategory].length;
        const nbPages = Math.ceil(nbHits / this.resultsInPage);
        if (nbPages > 1) {
            $pagination.append(`
        <div class="pagination-items">
          <button class="pagination-button-prev" id="prev-button" aria-label="Previous page" title="Previous page">
             <span class="icon icon-chevron_left" /> 
          </button>
          <div class="pagination-numbers">
          </div>
          <button class="pagination-button-next" id="next-button" aria-label="Next page" title="Next page">
            <span class="icon icon-chevron_right" /> 
          </button>
        </div>

    `);
            this._createPagination(nbHits, nbPages);
            const prev = document.body.querySelector(".pagination-button-prev");
            const next = document.body.querySelector(".pagination-button-next");
            prev.addEventListener("click", function(event) {
                event.preventDefault();
                event.stopPropagation();
                searchThis._setPageToPrev();
            });
            next.addEventListener("click", function(event) {
                event.preventDefault();
                event.stopPropagation();
                searchThis._setPageToNext();
            });
            this._handleActivePageNumber();
            this._handlePageButtonsStatus();
        } else this.allReaultsDisplayData = this.categorizedResults[this.pickedCategory];
    }
    _allResultModalFooterInfiniteScroll() {
        const searchThis = this;
        const nbHits = this.categorizedResults[this.pickedCategory].length;
        const nbPages = Math.ceil(nbHits / this.resultsInPage);
        if (nbPages > 1) $(".search-results-all").scroll(function() {
            if (Math.ceil($(this).scrollTop() + $(this).innerHeight()) >= $(this)[0].scrollHeight) searchThis._getNextResultsInfiniteScroll();
        });
        else this.allReaultsDisplayData = this.categorizedResults[this.pickedCategory];
    }
    _handleActiveCategory() {
        const allCategories = document.querySelectorAll(".all-results-category-container");
        allCategories.forEach((category)=>{
            category.classList.remove("active");
            if (category.innerText.includes(this.categories[this.pickedCategory].prettyName)) category.classList.add("active");
        });
    }
    _handleEnterAndEscapeKeys() {
        const searchThis = this;
        document.body.addEventListener("keydown", function(e) {
            if (e.key === "Escape") {
                e.preventDefault();
                searchThis._closeSearchDropdown();
            }
            if (e.key === "Enter") {
                e.preventDefault();
                searchThis._closeSearchDropdown();
                $(".show-all-results-container").click();
            }
        });
    }
    _openSearchDropdown() {
        const $siteHeader = $(".site-header-search input");
        const $searchDropdown = this.isSideSearch ? $(".sidebar-search-dropdown") : $(".search-dropdown");
        if (this.isSideSearch) {
            const $sidebar = $(".nav-site-sidebar");
            $sidebar.css("display", "none");
        }
        document.body.style.overflow = "hidden";
        $siteHeader[0].style.boxShadow = "0 0 0 9999px rgba(0, 0, 0, 0.5)";
        if (this.isSideSearch) $(".site-sidebar")[0].classList.add("full");
        $searchDropdown.show();
    }
    _closeSearchDropdown() {
        const $siteHeader = $(".site-header-search input");
        const $searchDropdown = $(".search-dropdown , .sidebar-search-dropdown");
        const $sidebar = $(".nav-site-sidebar");
        $siteHeader[0].style.boxShadow = "none";
        document.body.style.overflow = "visible";
        $sidebar.css("display", "block");
        if (this.isSideSearch) $(".site-sidebar")[0].classList.remove("full");
        $searchDropdown.hide();
    }
    _allResultModalHeader() {
        const $allResultsModalHeader = $(".all-results-category");
        const searchThis = this;
        Object.keys(this.categories).map((category)=>{
            const categoryContainer = document.createElement("div");
            const categoryText = document.createElement("span");
            categoryText.innerText = this.categories[category].prettyName;
            const categoryLength = document.createElement("div");
            categoryLength.className = "category-length";
            categoryLength.innerText = this.categorizedResults[category].length;
            categoryContainer.className = "all-results-category-container";
            categoryContainer.append(categoryText, categoryLength);
            if (this.categorizedResults[category].length <= 0) categoryContainer.classList.add("disabled");
            categoryContainer.addEventListener("click", function(event) {
                event.preventDefault();
                searchThis.pickedCategory = category;
                searchThis.currentPage = 1;
                searchThis.isSideSearch ? searchThis._allResultModalDisplayInfiniteScroll() : searchThis._allResultModalDisplayPagination();
            });
            $allResultsModalHeader.append(categoryContainer);
        });
    }
    _clearAllContainers() {
        $(".search-results-all").empty();
        $(".pagination-container").empty();
        $(".pagination-numbers").empty();
        $(".all-results-category").empty();
    }
    _sideSearchDropdownDisplay(length, nbHits) {
        const $searchResults = $(".search-results");
        $searchResults.append(`<span class="search-results-headline">RESULTS</span>`);
        document.addEventListener("gesturestart", function(e) {
            e.preventDefault();
        });
        for(const category in this.categorizedResults)if (this.categorizedResults[category].length > 0 && category !== "ALL") {
            this._assignIconToHit(category);
            $searchResults.append(`<div class="category-container"><li class="category">${this.categories[category].prettyName}</li></div>`);
            this.categorizedResults[category].forEach((hit, index)=>{
                if (index >= 2) return;
                this._appendResult($searchResults, hit);
            });
        }
        $searchResults.append(`<div class="show-all-results-container">
           <a> See all ${Math.min(length, nbHits)} results</a>
      </div>`);
    }
    _mainSearchDropdownDisplay(length, nbHits) {
        const $searchResults = $(".search-results");
        $searchResults.append(`<span class="search-results-headline">RESULTS</span>`);
        for(const category in this.categorizedResults)if (this.categorizedResults[category].length > 0 && category !== "ALL") {
            this._assignIconToHit(category);
            $searchResults.append(`<div class="category-container"><li class="category">${this.categories[category].prettyName}</li></div>`);
            this.categorizedResults[category].forEach((hit, index)=>{
                if (index >= 2) return;
                this._appendResult($searchResults, hit);
            });
        }
        $searchResults.append(`<div class="show-all-results-container">
           <a> See all ${Math.min(length, nbHits)} results</a>
      </div>`);
    }
    _searchDropdownDisplay() {
        const $searchResults = $(".search-results");
        const $searchBars = $(".site-header-search #search-bar, .site-sidebar-search #side-search-bar");
        const $searchDropdown = $(".search-dropdown");
        const searchThis = this;
        this._handleEnterAndEscapeKeys();
        this._emptySearchBarOnClick();
        $searchBars.on("focus", async function(event) {
            searchThis.isSideSearch = [
                ...event.currentTarget.form.classList
            ].includes("site-sidebar-search");
            const popularSearchResults = await searchThis.QuerySuggestionindex.search("", {
                hitsPerPage: 5
            });
            if (!$(this)[0].value.toString()) searchThis._openRecentAndPopularSearchesModal(popularSearchResults.hits || []);
            else searchThis._openSearchDropdown();
        });
        $searchBars.on("input", function() {
            searchThis.currentPage = 1;
            searchThis.query = $(this)[0].value.toString();
            searchThis.algoliaIndex.search(searchThis.query, {
                offset: 0,
                length: 1000
            }).then(({ hits: hits, nbHits: nbHits, length: length })=>{
                if (searchThis.query.length > 0 && hits.length) {
                    searchThis._sortHits(hits);
                    searchThis._initPickedCategory();
                    $searchResults.empty();
                    searchThis._openSearchDropdown();
                    if (searchThis.isSideSearch) searchThis._sideSearchDropdownDisplay(length, nbHits);
                    else searchThis._mainSearchDropdownDisplay(length, nbHits);
                } else if (nbHits === 0) {
                    $searchResults.empty();
                    $searchResults.append(`<div class="search-results-empty-container"><div class="search-results-empty"></div><span class="no-result-query"></span></div>`);
                    $(".no-result-query").text(`No results found for "${searchThis.query.toString()}".`);
                    searchThis._openSearchDropdown();
                    return;
                } else searchThis._closeSearchDropdown();
                $(".show-all-results-container").on("click", function(event) {
                    event.stopPropagation();
                    searchThis._closeSearchDropdown();
                    searchThis.isSideSearch ? searchThis._allResultModalDisplayInfiniteScroll() : searchThis._allResultModalDisplayPagination();
                });
            });
        });
        $(document).on("click", function(event) {
            if (!$(event.target).closest($searchDropdown).length && !$(event.target).closest($searchBars).length) searchThis._closeSearchDropdown();
            if ($(event.target).closest(".search-result-container").length) {
                const clickedContainer = $(event.target).closest(".search-result-container")[0];
                const url = clickedContainer.href;
                if (location.href === url) {
                    event.preventDefault();
                    searchThis._closeSearchDropdown();
                }
                const icon = clickedContainer.querySelector(".search-result-icon").classList;
                const title = clickedContainer.querySelector(".search-result-title").innerText;
                const breadcrumbs = clickedContainer.querySelector(".search-result-breadcrumbs").innerHTML;
                searchThis._closeAllResultsModal();
                $searchDropdown.hide();
                searchThis._addResultsToRecentSearches({
                    url: url,
                    icon: icon,
                    title: title,
                    breadcrumbs: breadcrumbs
                });
            }
            if ($(event.target).closest(".search-result-data.popular").length) {
                const clickedContainer = $(event.target).closest(".search-result-data.popular")[0];
                const query = clickedContainer.innerText;
                const $searchBar = searchThis.isSideSearch ? $(".site-sidebar-search #side-search-bar") : $(".site-header-search #search-bar");
                $searchBar[0].value = query;
                $searchBar.trigger("input");
            }
        });
    }
    _closeAllResultsModal() {
        const $allResultsModal = $(".all-results-modal");
        const $searchInput = this.isSideSearch ? $("#side-search-bar") : $("#search-bar");
        $allResultsModal.css("display", "none");
        $searchInput[0].value = "";
        document.body.style.overflow = "visible";
    }
    _openAllResultsModal() {
        const $allResultsModal = $(".all-results-modal");
        $allResultsModal.css("display", "flex");
        document.body.style.overflow = "hidden";
    }
    _emptySearchBarOnClick() {
        const $searchBarDelete = $(".icon-delete");
        const $searchBarInput = $(".search-input-container input");
        const $sideSearchBarInput = $("#side-search-bar");
        const searchThis = this;
        $searchBarDelete.on("click", function() {
            searchThis.query = "";
            searchThis.isSideSearch ? $sideSearchBarInput.val("") : $searchBarInput.val("");
        });
    }
    _allResultModalDisplayPagination() {
        const $exitModal = $(".exit-results-modal");
        const searchThis = this;
        this._clearAllContainers();
        this._openAllResultsModal();
        this._allResultModalHeader();
        this._displayAllResultPagination();
        $exitModal.on("click", function() {
            searchThis._closeAllResultsModal();
        });
        document.body.addEventListener("keydown", function(e) {
            if (e.key === "Escape") searchThis._closeAllResultsModal();
        });
    }
    _closeModalOnHamburgerClick() {
        const $hamburger = $(".navbar-toggle");
        const $modal = $(".all-results-modal");
        const searchThis = this;
        const isOpenModal = $modal.css("display") !== "none";
        if (isOpenModal) $hamburger.on("click", function() {
            searchThis._closeAllResultsModal();
        });
    }
    _allResultModalDisplayInfiniteScroll() {
        const $exitModal = $(".exit-results-modal");
        const searchThis = this;
        $(".pagination-container").css("display", "none");
        this._clearAllContainers();
        this._openAllResultsModal();
        this._allResultModalHeader();
        this._closeModalOnHamburgerClick();
        this._displayAllResultInfiniteScroll();
        $exitModal.on("click", function() {
            searchThis._closeAllResultsModal();
        });
    }
    _preventZoomOninputClick() {
        const metaTag = document.createElement("meta");
        metaTag.name = "viewport";
        metaTag.content = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0";
        document.getElementsByTagName("head")[0].appendChild(metaTag);
    }
    _initAlgoliaSearch() {
        this.categories = {
            ALL: {
                prettyName: "All",
                name: "all"
            },
            REF: {
                prettyName: "API Reference",
                name: "api-ref"
            },
            GUIDE: {
                prettyName: "Guides",
                name: "guide"
            },
            CP: {
                prettyName: "Client Portal",
                name: "cp"
            }
        };
        this._preventZoomOninputClick();
        this.currentPage = 1;
        this.pickedCategory = Object.keys(this.categories)[0];
        this._searchDropdownDisplay();
        document.addEventListener("click", function() {
            const $allResultsModal = $(".all-results-modal");
            $allResultsModal.css("display") === "flex" ? document.body.style.overflow = "hidden" : document.body.style.overflow = "visible";
        });
    }
}

});
parcelRegister("b4VQN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $810cf156a71ddb13$export$2e2bcd8739ae039; });
var $810cf156a71ddb13$export$2e2bcd8739ae039 = `
    <div class="sidebar-search-dropdown">
        <ul class="search-results"></ul>
    </div>
`;

});

parcelRegister("2J8js", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc63b8518586223$export$2e2bcd8739ae039; });
class $1fc63b8518586223$export$2e2bcd8739ae039 {
    static createScriptsAndAppend() {
        const autocompleteScript = document.createElement("script");
        autocompleteScript.type = "text/javascript";
        autocompleteScript.defer;
        autocompleteScript.src = "https://cdn.jsdelivr.net/npm/@algolia/autocomplete-js";
        const popularSearchesScript = document.createElement("script");
        popularSearchesScript.type = "text/javascript";
        autocompleteScript.defer;
        popularSearchesScript.src = "https://cdn.jsdelivr.net/npm/@algolia/autocomplete-plugin-query-suggestions@1.12.2/dist/umd/index.production.min.js";
        document.head.appendChild(autocompleteScript);
        document.head.appendChild(popularSearchesScript);
        return autocompleteScript;
    }
}

});


parcelRegister("eMLUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac3ab665f30ef4c7$export$2e2bcd8739ae039; });
const $ac3ab665f30ef4c7$var$ENTER_KEY_CODE = 13;
const $ac3ab665f30ef4c7$var$USER_TYPING_TIMEOUT = 200;
class $ac3ab665f30ef4c7$export$2e2bcd8739ae039 {
    constructor(){
        this.searchSidebarForm = $(".site-sidebar-search");
    }
    listenEvents() {
        this.searchSidebarForm.on("submit", (e)=>{
            e.preventDefault();
            setTimeout(()=>$(".site-sidebar").removeClass("in"), $ac3ab665f30ef4c7$var$USER_TYPING_TIMEOUT);
        });
        this.searchSidebarForm.on("keypress", "input", function(e) {
            if (e.which !== $ac3ab665f30ef4c7$var$ENTER_KEY_CODE) return;
            $(this).parent().submit();
            return false;
        });
    }
    stopListening() {
        this.searchSidebarForm.off("submit");
        this.searchSidebarForm.find("input").off("keypress");
    }
}

});

parcelRegister("lWyyq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff99d1876bb23733$export$2e2bcd8739ae039; });
var $ff99d1876bb23733$export$2e2bcd8739ae039 = `
  <form class="site-header-search">
    <div class="search-input-container">
        <span class="icon-search"></span>
        <input type="text" placeholder="Search Rapyd Docs" maxlength="30" class="form-control search-field" id="search-bar">
        <span class="icon-delete"></span>
    </div>
    <div class="search-dropdown">
        <ul class="search-results"></ul>
    </div>
  </form>
`;

});

parcelRegister("7zAu3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58381a34c0fe0e4a$export$2e2bcd8739ae039; });
var $58381a34c0fe0e4a$export$2e2bcd8739ae039 = `
  <form class="site-header-all-results">
    <div  class="all-results-modal">
        <div class="exit-all-result">
            <span class="exit-results-modal icon-delete"></span>
        </div>
        <div class="all-results-container">
            <div class="all-result-header">
                <span class="all-results-headline">Search Results</span>
                    <div class="all-results-category"></div>
            </div>
            <ul class="search-results-all"></ul>
        </div>
        <div class="pagination-container"></div>
    </div>
  </form>
`;

});

parcelRegister("49gYd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30552a99af6e81b1$export$2e2bcd8739ae039; });
var $30552a99af6e81b1$export$2e2bcd8739ae039 = `
  <a href="https://dashboard.rapyd.net/login" role="button" target="_blank" class="btn btn-primary login-btn">Log In</a>
`;

});

parcelRegister("4v18O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $346af145166795a3$export$2e2bcd8739ae039; });
var $346af145166795a3$export$2e2bcd8739ae039 = `
  <button class="theme-switcher"><div class="slider" /></button>
`;

});

parcelRegister("gzpGe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c103d5c20d174c85$export$2e2bcd8739ae039; });
var $c103d5c20d174c85$export$2e2bcd8739ae039 = `
<div class='page-footer'>
  <div class='footer-container'>
    <div class="informaltable footer-container table-responsive">
      <div class="preloader-container show">
        <div class="loader"></div>
      </div>
      <table class="informaltable frame-void rules-rows">
        <tbody>
          <tr>
            <td class="td">
              <p class="subscription-container">
              </p>
            </td>
            <td class="td">
              <div class="itemizedlist">
                <ul class="itemizedlist">
                  <li class="listitem">
                    <p>
                      <span class="icon icon-comment" /> 
                      Got feedback? 
                      <a class="link" href="https://forms.gle/RBnHjhYP2YVgj3dm9" target="_blank" rel="noopener">
                        Let us know.
                      </a>
                    </p>
                  </li>
                  <li class="listitem">
                    <p>
                      <span class="icon icon-link" /> 
                      Connect with 
                      <a class="link" href="https://community.rapyd.net/" target="_blank" rel="noopener">
                        Rapyd Developer Community
                      </a>
                    </p>
                  </li>
                  <li class="listitem">
                    <p>
                      <span class="icon icon-question-mark" /> 
                      Need help? 
                      <a class="link" href="https://dashboard.rapyd.net/login" target="_blank" rel="noopener">
                        Contact us.
                      </a>
                    </p>
                  </li>
                  <li class="listitem">
                    <p>
                      <span class="icon icon-privacy" /> 
                      <a class="link" href="https://www.rapyd.net/security-compliance/site-privacy-policy/" target="_blank" rel="noopener">
                        Privacy policy
                      </a>
                    </p>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
`;

});


parcelRegister("38e4d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $247d07dd44839898$export$2e2bcd8739ae039; });

var $2vRGl = parcelRequire("2vRGl");

var $2YOg9 = parcelRequire("2YOg9");

var $cgc5a = parcelRequire("cgc5a");

var $1Z80L = parcelRequire("1Z80L");

var $kCvAu = parcelRequire("kCvAu");

var $1H6WA = parcelRequire("1H6WA");

var $exgCs = parcelRequire("exgCs");

var $dbBDy = parcelRequire("dbBDy");
class $247d07dd44839898$export$2e2bcd8739ae039 {
    constructor(){
        this.classes = {
            tabs: (0, $2vRGl.default),
            customAccordions: (0, $cgc5a.default),
            apiParams: (0, $1Z80L.default),
            apiDropdown: (0, $kCvAu.default),
            codeBlocks: (0, $exgCs.default),
            dynamicTable: (0, $dbBDy.default)
        };
    }
    update() {
        this._injectDynamicContent();
        this._initializeDynamicContent();
        this._rerunPageListeners();
    }
    _injectDynamicContent() {
        $(".subscription-container").append(`<script id='hsforms-js' src='https://js.hsforms.net/forms/embed/v2.js'></script>`);
    }
    _rerunPageListeners() {
        this._reInitializeInstance("tabs");
        this._reInitializeInstance("codeBlocks");
        this._reInitializeInstance("customAccordions");
        this._reInitializeInstance("apiDropdown");
        if (document.body.querySelector(".payment-table-container")) this._reInitializeInstance("dynamicTable");
        this._reInitializeInstance("apiParams", this.customAccordions);
    }
    _initializeDynamicContent() {
        new (0, $1H6WA.default)(".accordion");
        new (0, $2YOg9.default)();
        $(".site-sidebar").removeClass("in");
    }
    _reInitializeInstance(instanceName, ...args) {
        if (this[instanceName]) {
            this[instanceName].stopListening();
            delete this[instanceName];
        }
        this[instanceName] = new this.classes[instanceName](...args);
        this[instanceName].listenEvents();
    }
}

});
parcelRegister("2vRGl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d481e1f8d47dcd3$export$2e2bcd8739ae039; });
class $1d481e1f8d47dcd3$export$2e2bcd8739ae039 {
    constructor(){
        this.tabsContainers = $(".tabbed-table-container");
        this.tabsContainers.each(function() {
            $(this).find("ul.tabbed-panel").removeClass("active").eq(0).addClass("active");
        });
    }
    listenEvents() {
        this.tabsContainers.on("click", "ul.tabbed-panel", function() {
            const tab = $(this);
            tab.parents().eq(2).find("ul.tabbed-panel").removeClass("active");
            tab.addClass("active");
        });
    }
    stopListening() {
        this.tabsContainers.off("click");
    }
}

});

parcelRegister("2YOg9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22b82bd79a261b20$export$2e2bcd8739ae039; });
class $22b82bd79a261b20$export$2e2bcd8739ae039 {
    constructor(){
        $(".card.link").each(function() {
            const linkWrapper = document.createElement("a");
            linkWrapper.setAttribute("class", $(this).attr("class"));
            const link = $(this).find(".card-link").text();
            linkWrapper.setAttribute("href", link.startsWith("http") ? link : DOC_URL + link);
            linkWrapper.innerHTML = this.innerHTML;
            $(this).replaceWith(linkWrapper);
        });
    }
}

});

parcelRegister("cgc5a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ed059f192e0686b$export$2e2bcd8739ae039; });
class $8ed059f192e0686b$export$2e2bcd8739ae039 {
    constructor(){
        this.accordions = $(".inner-accordion");
        this.accordions.attr("aria-expanded", "true");
        this.collapsedByDefault = $(".inner-accordion:not(.open)");
        this.collapseDefault();
    }
    listenEvents() {
        this.accordions.find("> p").on("click", function() {
            const header = $(this);
            if (header.parent().attr("aria-expanded") === "true") {
                header.parent().attr("aria-expanded", "false");
                header.next().slideUp(0);
            } else {
                header.next().slideDown(0);
                header.parent().attr("aria-expanded", "true");
            }
        });
    }
    stopListening() {
        this.accordions.off("click");
    }
    expandAll() {
        this.accordions.attr("aria-expanded", "true");
        this.accordions.find("> div").slideDown(0);
    }
    collapseAll() {
        this.accordions.attr("aria-expanded", "false");
        this.accordions.find("> div").slideUp(0);
    }
    collapseDefault() {
        this.collapsedByDefault.attr("aria-expanded", "false");
        this.collapsedByDefault.find("> div").slideUp(0);
    }
}

});

parcelRegister("1Z80L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1721b3d66458d65f$export$2e2bcd8739ae039; });

var $1H6WA = parcelRequire("1H6WA");
class $1721b3d66458d65f$export$2e2bcd8739ae039 {
    constructor(customAccordions){
        this.apiParamsPanelHeader = $(".section.api-method-parameters > .accordion > .panel > .panel-heading");
        this.apiParamsPanelHeader.find(".title").attr("collapse-status", "Collapse");
        this.customAccordions = customAccordions;
    }
    listenEvents() {
        const self = this;
        this.apiParamsPanelHeader.on("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            const panelHeader = $(this);
            const allCollapsed = panelHeader.find(".title").attr("collapse-status") === "Expand";
            const apiParamsAccordions = new (0, $1H6WA.default)(".section.api-method-parameters .panel-body .accordion");
            panelHeader.find(".title").attr("collapse-status", allCollapsed ? "Collapse" : "Expand");
            if (allCollapsed) {
                apiParamsAccordions.expandAll();
                self.customAccordions.expandAll();
            } else {
                apiParamsAccordions.collapseAll();
                self.customAccordions.collapseAll();
            }
        });
    }
    stopListening() {
        this.apiParamsPanelHeader.off("click");
    }
}

});
parcelRegister("1H6WA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13bf3187a6e75424$export$2e2bcd8739ae039; });
class $13bf3187a6e75424$export$2e2bcd8739ae039 {
    constructor(selector){
        this.accordions = $(selector);
        this.expandedByDefault = $(`${selector}.section.open`);
        this.expandDefault();
    }
    expandAll() {
        this.accordions.find("> .panel > .panel-body").addClass("in").attr("aria-expanded", "true").css("height", "");
        this.accordions.find("> .panel > .panel-heading").addClass("active");
    }
    collapseAll() {
        this.accordions.find("> .panel > .panel-body").removeClass("in").attr("aria-expanded", "false").css("height", "0");
        this.accordions.find("> .panel > .panel-heading").removeClass("active");
    }
    expandDefault() {
        this.expandedByDefault.find("> .panel > .panel-body").addClass("in").attr("aria-expanded", "true").css("height", "");
        this.expandedByDefault.find("> .panel > .panel-heading").addClass("active");
    }
}

});


parcelRegister("kCvAu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f02fdbe3d7a861e5$export$2e2bcd8739ae039; });
class $f02fdbe3d7a861e5$export$2e2bcd8739ae039 {
    constructor(){
        this.endpoint = $(".endpoint ul");
        this.endpoint.find("p:nth-of-type(2)").remove();
        const options = $(".api-method-example ul.itemizedlist li:first-of-type p").map((i, el)=>`<option value=${i}>${el.innerHTML}</option>`);
        const dropdown = `<select class="form-control" id="api-select">${Object.values(options).join()}</select>`;
        this.endpoint.append(dropdown);
        this.apiContainer = $(`div.api-method-example`);
        this.apiContainer.eq(0).addClass("active");
        const webhookCaption = this.apiContainer.find("li.listitem:first-child p").text();
        this.apiContainer.find(".example-webhook").attr("data-content", webhookCaption || "Example Webhook");
        this.apiSelect = $("#api-select");
    }
    listenEvents() {
        this.apiSelect.on("change", (e)=>{
            const index = e.target.value;
            this.apiContainer.removeClass("active");
            this.apiContainer.eq(index).addClass("active");
        });
    }
    stopListening() {
        this.apiSelect.off("change");
    }
}

});

parcelRegister("exgCs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a95109fc0dbd349a$export$2e2bcd8739ae039; });
class $a95109fc0dbd349a$export$2e2bcd8739ae039 {
    constructor(){
        this.standaloneCodeBlocks = $(".code-block.standalone");
        this.regularCodeBlocks = $(".code-block");
        this.standaloneCodeBlocks.find("+ button > i").removeClass("fa fa-clipboard small").addClass("icon-copy");
        this.regularCodeBlocks.find("button > i").removeClass("fa fa-clipboard small").addClass("icon-copy");
    }
    listenEvents() {
        function listenerFunction() {
            setTimeout(()=>$(this).find("i").removeClass("fa fa-clipboard small").addClass("icon-copy"), 1000);
        }
        this.standaloneCodeBlocks.find("+ button").on("click", listenerFunction);
        this.regularCodeBlocks.find("button").on("click", listenerFunction);
    }
    stopListening() {
        this.standaloneCodeBlocks.find("+ button").off("click");
        this.regularCodeBlocks.find("button").off("click");
    }
}

});

parcelRegister("dbBDy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99997f58fb1784ba$export$2e2bcd8739ae039; });

var $1OSVr = parcelRequire("1OSVr");

var $3EWwR = parcelRequire("3EWwR");
class $99997f58fb1784ba$export$2e2bcd8739ae039 {
    constructor(){
        this.jsonData = {};
        this.data = {};
        this.isLoading = true;
        this.countriesToRemove = (0, $1OSVr.countriesToRemove);
        this.countryOptins = (0, $3EWwR.countryOptins);
        this.loader = '<div class="preloader-container-table show"><div class="loader-table"></div></div>';
        this.tableContainer = $(".payment-table-container");
        $(".payment-table-container .informaltable.table-responsive").addClass("hidden");
        this.tableContainer.append(this.loader);
        this.generateTable();
        this.links = this.linksToPMTNames();
    }
    async getJsonData() {
        this.isLoading = true;
        const response = await fetch(`${DOC_URL}services/pmt.json`);
        if (response) this.isLoading = false;
        this.jsonData = await response.json();
    }
    getIsoCountry(country) {
        const entry = this.countryOptins.find((item)=>item.label === country);
        return entry ? entry.value.toUpperCase() : null;
    }
    groupDataByNameAndRemoveAfrinicRegion() {
        this.jsonData = this.jsonData.filter((item)=>{
            if (typeof item.country === "string") {
                item.country = item.country.replace(/'/g, '"');
                item.country = JSON.parse(item.country);
            }
            if (item.country && item.country.length > 0) {
                item.country = item.country.filter((country)=>!this.countriesToRemove.includes(country?.toUpperCase()));
                return item.country.length > 0;
            }
            return false;
        });
        return this.jsonData.reduce((acc, item)=>{
            const existingItem = acc.find((groupedItem)=>groupedItem.payment_method_type_name === item.payment_method_type_name);
            if (existingItem) existingItem.country = Array.from(new Set(existingItem.country.concat(item.country)));
            else acc.push({
                ...item,
                country: item.country
            });
            return acc;
        }, []);
    }
    linksToPMTNames() {
        const links = [];
        const ulElements = document.querySelectorAll(".links ~ ul");
        ulElements.forEach((ul)=>{
            ul.querySelectorAll("li").forEach((li)=>{
                const title = li.textContent.trim();
                const link = li.querySelector("a").getAttribute("href");
                links.push({
                    title: title,
                    link: link
                });
            });
        });
        return links;
    }
    async convertJsonData() {
        await this.getJsonData();
        this.jsonData = this.groupDataByNameAndRemoveAfrinicRegion();
        return this.jsonData.map((entry)=>({
                payment_method: entry.payment_method_type_name || "",
                countries: typeof entry.country === "string" ? JSON.parse(entry.country) : entry.country || [],
                categories: typeof entry.catgories === "string" ? JSON.parse(entry.catgories) : entry.catgories || [],
                currencies: typeof entry.currencies === "string" ? JSON.parse(entry.currencies) : entry.currencies || [],
                features: {
                    refundable: entry.payment_method_type_is_refundable,
                    cancelable: entry.payment_method_type_is_cancelable,
                    subscription: entry.subscription_availability,
                    dispute: true
                },
                country_iso_alpha2: entry.payment_method_type_country_iso_alpha2 || "[]"
            }));
    }
    capitalizeAndRemoveUnderscore(str) {
        if (str) return str?.split("_").map((word)=>`${word.charAt(0).toUpperCase()}${word.slice(1)}`).join(" ") || str;
    }
    formatNameWithLink(val) {
        if (val) {
            const foundLink = this.links.find((link)=>link.title.toLowerCase() === val.toLowerCase());
            if (foundLink) return `${DOC_URL}en/${foundLink.link}`;
        }
    }
    getFlagURL(country) {
        const countryCode = this.getIsoCountry(country);
        return `../assets/flags/1x1/${countryCode}.svg`;
    }
    getAllUniqueCurrencies() {
        const allCurrencies = this.data.flatMap((row)=>row.currencies);
        return [
            ...new Set(allCurrencies)
        ];
    }
    getAllUniqueCountries() {
        const allCountries = this.data.flatMap((row)=>row.countries);
        const countries = allCountries.map((country)=>this.capitalizeAndRemoveUnderscore(country));
        return [
            ...new Set(countries)
        ];
    }
    getAllUniqueCategories() {
        const allCategories = this.data.flatMap((row)=>row.categories);
        return [
            ...new Set(allCategories)
        ];
    }
    generateHeader() {
        const headerRow = $("<tr>");
        const allCurrencies = this.getAllUniqueCurrencies();
        const allCountries = this.getAllUniqueCountries();
        const allCategories = this.getAllUniqueCategories();
        for(const key in this.data[0]){
            if (key === "country_iso_alpha2") continue;
            const filterButton = key !== "features" ? `<button class='dropbtn'><span class='filter-icon'/></button>` : "";
            let dropdownValues;
            if (key === "categories") dropdownValues = allCategories.map((value)=>`
              <label class='custom-checkbox'>
                <input type='checkbox' id='${key}-${value}' value='${value}'>
                <span class='checkmark'></span>
                ${this.capitalizeAndRemoveUnderscore(value)}
              </label>
            `);
            else if (key === "currencies") dropdownValues = allCurrencies.map((value)=>`
              <label class='custom-checkbox'>
                <input type='checkbox' id='${key}-${value}' value='${value}'>
                <span class='checkmark'></span>
                ${value}
              </label>
            `);
            else if (key === "countries") {
                const countries = allCountries.filter((str)=>!str?.includes("dIvoire"));
                dropdownValues = countries.map((value)=>`
                  <label class='custom-checkbox'>
                    <input type='checkbox' id='${key}-${value}' value='${value}'>
                    <span class='flag-icon' style='--flag-url: url(${this.getFlagURL(value)})'></span>
                    <span class='checkmark'></span>
                    ${this.capitalizeAndRemoveUnderscore(value)}
                  </label>
                `);
            } else {
                const uniqueValuesSet = new Set();
                dropdownValues = this.data.map((record)=>record[key]).filter((value, index, self)=>value && self.indexOf(value) === index).filter((value)=>{
                    if (!uniqueValuesSet.has(value)) {
                        uniqueValuesSet.add(value);
                        return true;
                    }
                    return false;
                }).map((value)=>`
            <label class='custom-checkbox'>
                <input type='checkbox' id='${key}-${value}' value='${value}'>
                <div className="icon" />
                <span class='checkmark'></span>
                ${key === "category" ? this.capitalizeAndRemoveUnderscore(value) : value}
            </label>
        `);
            }
            const resetButton = `<div class='reset-btn-container'><span class='reset-btn-icon'/><button class='reset-btn'>Reset Selection</button></div>`;
            const th = $(`
      <th>
        <div class='dropdown'>
          <span>${this.capitalizeAndRemoveUnderscore(key)}</span>
          ${filterButton}
          <div class='${key}-dropdown-content-container'>
            <div class='dropdown-content' id='${key}-dropdown'>
              <div id='input_container'>
                <input type='text' id='search-dropdown' placeholder='Search' minlength="2" maxlength="25">
              </div>
              <div class='list-container'>
              ${dropdownValues.join("")}
               </div>
               ${resetButton}
            </div>
          </div>
        </div>
      </th>
    `);
            headerRow.append(th);
        }
        return headerRow;
    }
    async generateTable() {
        this.data = await this.convertJsonData();
        if (!this.isLoading) {
            $(".preloader-container-table").removeClass("show");
            $(".preloader-container-table").addClass("hidden");
            $(".payment-table-container .informaltable.table-responsive").removeClass("hidden");
            const table = $('<table id="payments-table">');
            const headerRow = this.generateHeader();
            table.append(headerRow);
            table.append(this.generateTbody(this.data));
            const existingTable = this.tableContainer.find("table");
            if (existingTable.length) existingTable.replaceWith(table);
            else this.tableContainer.append(table);
            const searchInputs = this.tableContainer.find('input[type="text"]');
            searchInputs.on("input", (event)=>{
                const searchText = event.target.value;
                const dropdownContent = $(event.target).closest(".dropdown-content");
                this.filterCheckboxes(searchText, dropdownContent);
            });
        }
        this.listenEvents();
    }
    generateFeatures(features) {
        return [
            "refundable",
            "cancelable",
            "subscription",
            "dispute"
        ].map((featureKey)=>{
            const uiContainer = document.createElement("div");
            const text = document.createElement("span");
            text.className = "features-text";
            text.textContent = this.capitalizeAndRemoveUnderscore(featureKey);
            uiContainer.className = features[featureKey] ? "check_text" : "delete_text";
            const iconSpan = document.createElement("span");
            iconSpan.className = features[featureKey] ? "check" : "delete";
            uiContainer.appendChild(iconSpan);
            uiContainer.appendChild(text);
            return uiContainer;
        });
    }
    generateContent(content) {
        const truncatedContent = document.createElement("div");
        if (content.length > 200 || Array.isArray(content) && content.length > 10) {
            if (Array.isArray(content)) truncatedContent.textContent = content.slice(0, 4) + "...";
            else truncatedContent.textContent = content.substring(0, 200) + "...";
            const fullContent = document.createElement("div");
            fullContent.textContent = content;
            fullContent.style.display = "none";
            const showMoreButton = document.createElement("span");
            showMoreButton.textContent = "Show More";
            showMoreButton.className = "show-more-button";
            showMoreButton.addEventListener("click", ()=>{
                this.toggleTextView(fullContent, truncatedContent, showMoreButton);
            });
            return [
                truncatedContent,
                fullContent,
                showMoreButton
            ];
        } else {
            const fullContent = document.createElement("div");
            fullContent.textContent = content;
            return [
                fullContent
            ];
        }
    }
    generateTbody(data) {
        const tbody = $("<tbody>");
        data.forEach((record)=>{
            const dataRow = $("<tr>");
            for(const key in record){
                if (key === "country_iso_alpha2") continue;
                const tableCell = document.createElement("td");
                switch(key){
                    case "payment_method":
                        {
                            const link = this.formatNameWithLink(record[key]);
                            const container = document.createElement("div");
                            container.className = "payment_method-container";
                            if (link) {
                                const a = document.createElement("a");
                                a.textContent = record[key];
                                a.href = link;
                                container.append(a);
                            } else container.textContent = record[key];
                            tableCell.append(container);
                            dataRow.append(tableCell);
                            break;
                        }
                    case "countries":
                        const prettyCountries = record[key].map((val)=>this.capitalizeAndRemoveUnderscore(val));
                        const newSetprettyCountriesCountries = [
                            ...new Set(prettyCountries)
                        ];
                        const containerCountries = this.generateContent(newSetprettyCountriesCountries);
                        containerCountries.forEach((element)=>{
                            tableCell.append(element);
                        });
                        break;
                    case "categories":
                        const containerCatgories = document.createElement("div");
                        const prettyCatgories = record[key].map((val)=>this.capitalizeAndRemoveUnderscore(val));
                        const newSet = [
                            ...new Set(prettyCatgories)
                        ];
                        containerCatgories.innerText = newSet;
                        tableCell.append(containerCatgories);
                        dataRow.append(tableCell);
                        break;
                    case "features":
                        const container = document.createElement("div");
                        container.className = "features-container";
                        const elements = this.generateFeatures(record[key]);
                        elements.forEach((element)=>{
                            container.appendChild(element);
                        });
                        tableCell.append(container);
                        dataRow.append(tableCell);
                        break;
                    default:
                        const elementsGenerated = this.generateContent(record[key]);
                        elementsGenerated.forEach((element)=>{
                            tableCell.append(element);
                        });
                        break;
                }
                dataRow.append(tableCell);
            }
            tbody.append(dataRow);
        });
        return tbody;
    }
    filterCheckboxes(searchText, dropdownContent) {
        $(".custom-checkbox", dropdownContent).each(function() {
            $(this).toggle($(this).text().toLowerCase().includes(searchText.toLowerCase()));
        });
    }
    filterJSON(data, filters1) {
        return data.filter((record)=>{
            return Object.keys(filters1).every((key)=>{
                const filterValues = filters1[key];
                if (filterValues.length === 0) return true;
                if (key === "currencies" || key === "countries" || key === "categories") return record[key].some((currency)=>filterValues.includes(currency));
                else return filterValues.includes(record[key]);
            });
        });
    }
    filterData(filteredData) {
        this.updateTableBody(filteredData);
    }
    toggleTextView(fullContent, truncatedContent, showMoreButton) {
        const isHidden = fullContent.style.display === "none";
        if (isHidden) {
            fullContent.style.display = "inline";
            truncatedContent.style.display = "none";
            showMoreButton.textContent = "Show Less";
        } else {
            fullContent.style.display = "none";
            truncatedContent.style.display = "inline"; // Set truncated content to display
            showMoreButton.textContent = "Show More";
        }
    }
    updateTableBody(filteredData) {
        const table = this.tableContainer.find("table");
        const tbody = table.find("tbody");
        tbody.empty();
        const tbodyDom = this.generateTbody(filteredData, tbody);
        table.append(tbodyDom);
    }
    updateSelectedFilters(container, key, values) {
        container.innerHTML = "";
        if (values.length > 0) values.forEach((value)=>{
            const filterItem = document.createElement("div");
            filterItem.className = "selected-filter";
            filterItem.textContent = `${key}: ${value}`;
            const removeIcon = document.createElement("span");
            removeIcon.className = "remove-filter-icon";
            removeIcon.addEventListener("click", ()=>{
                // Remove the filter when the remove icon is clicked
                const index = filters[key].indexOf(value);
                if (index !== -1) filters[key].splice(index, 1);
                checkbox.checked = false;
                const filteredData = this.filterJSON(this.data, filters);
                this.filterData(filteredData);
                this.updateSelectedFilters(container, key, filters[key]);
            });
            filterItem.appendChild(removeIcon);
            container.appendChild(filterItem);
        });
    }
    listenEvents() {
        const dropdownContents = document.querySelectorAll(".dropdown-content");
        const filters1 = {};
        dropdownContents.forEach((content)=>{
            const checkboxes = content.querySelectorAll('input[type="checkbox"]');
            const dropdownTrigger = content.closest(".dropdown").querySelector(".dropbtn");
            const resetButton = content.querySelector(".reset-btn-container");
            const filterIcon = dropdownTrigger.querySelector(".filter-icon");
            const selectedFiltersContainer = content.querySelector(".selected-filters-container");
            let isCheckboxChecked = false;
            dropdownTrigger.addEventListener("click", (event)=>{
                event.stopPropagation();
                const isHidden = content.style.display === "none";
                dropdownTrigger.className = isHidden && isCheckboxChecked ? "bth-click" : "dropbtn";
                dropdownContents.forEach((otherContent)=>{
                    if (otherContent !== content) otherContent.style.display = "none";
                });
                content.style.display = isHidden ? "block" : "none";
                if (!isHidden) {
                    const filteredData = this.filterJSON(this.data, filters1);
                    this.filterData(filteredData);
                }
            });
            filterIcon.addEventListener("click", (event)=>{
                event.stopPropagation();
                content.style.display = "none";
            });
            resetButton.addEventListener("click", (event)=>{
                event.stopPropagation();
                const searchInput = $(event.target).closest(".dropdown-content").find("#search-dropdown");
                searchInput.val("");
                checkboxes.forEach((checkbox1)=>{
                    checkbox1.checked = false;
                });
                const key = checkboxes[0].id.split("-")[0];
                filters1[key] = [];
                dropdownTrigger.className = "dropbtn";
                searchInput.trigger("input");
                const filteredData = this.filterJSON(this.data, filters1);
                this.filterData(filteredData);
            });
            checkboxes.forEach((checkbox1, index)=>{
                checkbox1.addEventListener("click", (event)=>{
                    event.stopPropagation();
                    isCheckboxChecked = Array.from(checkboxes).some((chk)=>chk.checked);
                    dropdownTrigger.className = isCheckboxChecked ? "bth-click" : "dropbtn";
                    checkboxes.forEach((checkbox1)=>{
                        const key = checkbox1.id.split("-")[0];
                        const value = checkbox1.value;
                        filters1[key] = Array.from(checkboxes).filter((chk)=>chk.checked && chk.value !== "all").map((chk)=>chk.value);
                        const filteredData = this.filterJSON(this.data, filters1);
                        this.filterData(filteredData);
                        this.updateSelectedFilters(selectedFiltersContainer, key, filters1[key]);
                    });
                });
            });
            document.addEventListener("click", (event)=>{
                const targetElement = event.target;
                if (!content.contains(targetElement) && !dropdownTrigger.contains(targetElement) && !filterIcon.contains(targetElement)) content.style.display = "none";
            });
        });
    }
    stopListening() {}
}

});
parcelRegister("1OSVr", function(module, exports) {

$parcel$export(module.exports, "countriesToRemove", function () { return $153510fd626c69c2$export$bf42852c9ca36054; });
const $153510fd626c69c2$export$bf42852c9ca36054 = [
    "ALGERIA",
    "ANGOLA",
    "BENIN",
    "BOTSWANA",
    "BURKINA FASO",
    "BURUNDI",
    "CAMEROON",
    "CAPE VERDE",
    "CENTRAL AFRICAN REPUBLIC",
    "CHAD",
    "COMOROS",
    "CONGO",
    "CONGO, THE DEMOCRATIC REPUBLIC OF THE",
    "CONGO, REPUBLIC (BRAZZAVILLE)",
    "COTE D\u2019IVOIRE",
    "DJIBOUTI",
    "EGYPT",
    "EQUATORIAL GUINEA",
    "ERITREA",
    "ETHIOPIA",
    "GABON",
    "GAMBIA",
    "GHANA",
    "GUINEA",
    "GUINEA-BISSAU",
    "KENYA",
    "LESOTHO",
    "LIBERIA",
    "DIVOIRE",
    "LIBYAN ARAB JAMAHIRIYA",
    "MADAGASCAR",
    "MALI",
    "MALAWI",
    "MAURITANIA",
    "MAURITIUS",
    "MAYOTTE",
    "MOROCCO",
    "MOZAMBIQUE",
    "NAMIBIA",
    "NIGER",
    "NIGERIA",
    "REUNION ISLAND",
    "RWANDA",
    "SAO TOME AND PRINCIPE",
    "SENEGAL",
    "SEYCHELLES",
    "SIERRA LEONE",
    "SOMALIA",
    "SOUTH AFRICA",
    "SOUTH SUDAN",
    "SUDAN",
    "SWAZILAND",
    "TANZANIA, UNITED REPUBLIC OF",
    "TOGO",
    "TUNISIA",
    "UGANDA",
    "WESTERN SAHARA",
    "ZAMBIA",
    "ZIMBABWE"
];

});

parcelRegister("3EWwR", function(module, exports) {

$parcel$export(module.exports, "countryOptins", function () { return $2aa2822d9baee786$export$e2f4efb1c5831bc0; });
const $2aa2822d9baee786$export$e2f4efb1c5831bc0 = [
    {
        label: "Afghanistan",
        value: "AF",
        id: "AF"
    },
    {
        label: "Albania",
        value: "AL",
        id: "AL"
    },
    {
        label: "Algeria",
        value: "DZ",
        id: "DZ"
    },
    {
        label: "Andorra",
        value: "AD",
        id: "AD"
    },
    {
        label: "Angola",
        value: "AO",
        id: "AO"
    },
    {
        label: "Anguilla",
        value: "AI",
        id: "AI"
    },
    {
        label: "Antarctica",
        value: "AQ",
        id: "AQ"
    },
    {
        label: "Antigua and Barbuda",
        value: "AG",
        id: "AG"
    },
    {
        label: "Argentina",
        value: "AR",
        id: "AR"
    },
    {
        label: "Armenia",
        value: "AM",
        id: "AM"
    },
    {
        label: "Aruba",
        value: "AW",
        id: "AW"
    },
    {
        label: "Australia",
        value: "AU",
        id: "AU"
    },
    {
        label: "Austria",
        value: "AT",
        id: "AT"
    },
    {
        label: "Azerbaijan",
        value: "AZ",
        id: "AZ"
    },
    {
        label: "Bahamas",
        value: "BS",
        id: "BS"
    },
    {
        label: "Bahrain",
        value: "BH",
        id: "BH"
    },
    {
        label: "Bangladesh",
        value: "BD",
        id: "BD"
    },
    {
        label: "Barbados",
        value: "BB",
        id: "BB"
    },
    {
        label: "Belarus",
        value: "BY",
        id: "BY"
    },
    {
        label: "Belgium",
        value: "BE",
        id: "BE"
    },
    {
        label: "Belize",
        value: "BZ",
        id: "BZ"
    },
    {
        label: "Benin",
        value: "BJ",
        id: "BJ"
    },
    {
        label: "Bermuda",
        value: "BM",
        id: "BM"
    },
    {
        label: "Bhutan",
        value: "BT",
        id: "BT"
    },
    {
        label: "Bolivia (Plurinational State of)",
        value: "BO",
        id: "BO"
    },
    {
        label: "Bonaire, Sint Eustatius and Saba",
        value: "BQ",
        id: "BQ"
    },
    {
        label: "Bosnia and Herzegovina",
        value: "BA",
        id: "BA"
    },
    {
        label: "Botswana",
        value: "BW",
        id: "BW"
    },
    {
        label: "Bouvet Island",
        value: "BV",
        id: "BV"
    },
    {
        label: "Brazil",
        value: "BR",
        id: "BR"
    },
    {
        label: "British Indian Ocean Territory",
        value: "IO",
        id: "IO"
    },
    {
        label: "Brunei Darussalam",
        value: "BN",
        id: "BN"
    },
    {
        label: "Bulgaria",
        value: "BG",
        id: "BG"
    },
    {
        label: "Burkina Faso",
        value: "BF",
        id: "BF"
    },
    {
        label: "Burundi",
        value: "BI",
        id: "BI"
    },
    {
        label: "Cabo Verde",
        value: "CV",
        id: "CV"
    },
    {
        label: "Cambodia",
        value: "KH",
        id: "KH"
    },
    {
        label: "Cameroon",
        value: "CM",
        id: "CM"
    },
    {
        label: "Canada",
        value: "CA",
        id: "CA"
    },
    {
        label: "Cayman Islands",
        value: "KY",
        id: "KY"
    },
    {
        label: "Central African Republic",
        value: "CF",
        id: "CF"
    },
    {
        label: "Chad",
        value: "TD",
        id: "TD"
    },
    {
        label: "Chile",
        value: "CL",
        id: "CL"
    },
    {
        label: "China",
        value: "CN",
        id: "CN"
    },
    {
        label: "Christmas Island",
        value: "CX",
        id: "CX"
    },
    {
        label: "Cocos (Keeling) Islands",
        value: "CC",
        id: "CC"
    },
    {
        label: "Colombia",
        value: "CO",
        id: "CO"
    },
    {
        label: "Comoros",
        value: "KM",
        id: "KM"
    },
    {
        label: "Congo, Democratic Republic",
        value: "CG",
        id: "CG"
    },
    {
        label: "Congo, Republic (Kinshasa)",
        value: "CD",
        id: "CD"
    },
    {
        label: "Cook Islands",
        value: "CK",
        id: "CK"
    },
    {
        label: "Costa Rica",
        value: "CR",
        id: "CR"
    },
    {
        label: "Croatia",
        value: "HR",
        id: "HR"
    },
    {
        label: "Cuba",
        value: "CU",
        id: "CU"
    },
    {
        label: "Cura\u05B3\xa7ao",
        value: "CW",
        id: "CW"
    },
    {
        label: "Cyprus",
        value: "CY",
        id: "CY"
    },
    {
        label: "Czech Republic",
        value: "CZ",
        id: "CZ"
    },
    {
        label: "C\u05B3te dIvoire",
        value: "CI",
        id: "CI"
    },
    {
        label: "Denmark",
        value: "DK",
        id: "DK"
    },
    {
        label: "Djibouti",
        value: "DJ",
        id: "DJ"
    },
    {
        label: "Dominica",
        value: "DM",
        id: "DM"
    },
    {
        label: "Dominican Republic",
        value: "DO",
        id: "DO"
    },
    {
        label: "Ecuador",
        value: "EC",
        id: "EC"
    },
    {
        label: "Egypt",
        value: "EG",
        id: "EG"
    },
    {
        label: "El Salvador",
        value: "SV",
        id: "SV"
    },
    {
        label: "Equatorial Guinea",
        value: "GQ",
        id: "GQ"
    },
    {
        label: "Eritrea",
        value: "ER",
        id: "ER"
    },
    {
        label: "Estonia",
        value: "EE",
        id: "EE"
    },
    {
        label: "Ethiopia",
        value: "ET",
        id: "ET"
    },
    {
        label: "Falkland Islands (Malvinas)",
        value: "FK",
        id: "FK"
    },
    {
        label: "Faroe Islands",
        value: "FO",
        id: "FO"
    },
    {
        label: "Fiji",
        value: "FJ",
        id: "FJ"
    },
    {
        label: "Finland",
        value: "FI",
        id: "FI"
    },
    {
        label: "France",
        value: "FR",
        id: "FR"
    },
    {
        label: "French Guiana",
        value: "GF",
        id: "GF"
    },
    {
        label: "French Polynesia",
        value: "PF",
        id: "PF"
    },
    {
        label: "French Southern Territories",
        value: "TF",
        id: "TF"
    },
    {
        label: "Gabon",
        value: "GA",
        id: "GA"
    },
    {
        label: "Gambia",
        value: "GM",
        id: "GM"
    },
    {
        label: "Georgia",
        value: "GE",
        id: "GE"
    },
    {
        label: "Germany",
        value: "DE",
        id: "DE"
    },
    {
        label: "Ghana",
        value: "GH",
        id: "GH"
    },
    {
        label: "Gibraltar",
        value: "GI",
        id: "GI"
    },
    {
        label: "Greece",
        value: "GR",
        id: "GR"
    },
    {
        label: "Greenland",
        value: "GL",
        id: "GL"
    },
    {
        label: "Grenada",
        value: "GD",
        id: "GD"
    },
    {
        label: "Guadeloupe",
        value: "GP",
        id: "GP"
    },
    {
        label: "Guam",
        value: "GU",
        id: "GU"
    },
    {
        label: "Guatemala",
        value: "GT",
        id: "GT"
    },
    {
        label: "Guernsey",
        value: "GG",
        id: "GG"
    },
    {
        label: "Guinea",
        value: "GN",
        id: "GN"
    },
    {
        label: "Guinea-Bissau",
        value: "GW",
        id: "GW"
    },
    {
        label: "Guyana",
        value: "GY",
        id: "GY"
    },
    {
        label: "Haiti",
        value: "HT",
        id: "HT"
    },
    {
        label: "Heard Island and McDonald Islands",
        value: "HM",
        id: "HM"
    },
    {
        label: "Honduras",
        value: "HN",
        id: "HN"
    },
    {
        label: "Hong Kong",
        value: "HK",
        id: "HK"
    },
    {
        label: "Hungary",
        value: "HU",
        id: "HU"
    },
    {
        label: "Iceland",
        value: "IS",
        id: "IS"
    },
    {
        label: "India",
        value: "IN",
        id: "IN"
    },
    {
        label: "Indonesia",
        value: "ID",
        id: "ID"
    },
    {
        label: "Iran",
        value: "IR",
        id: "IR"
    },
    {
        label: "Iraq",
        value: "IQ",
        id: "IQ"
    },
    {
        label: "Ireland",
        value: "IE",
        id: "IE"
    },
    {
        label: "Isle of Man",
        value: "IM",
        id: "IM"
    },
    {
        label: "Israel",
        value: "IL",
        id: "IL"
    },
    {
        label: "Italy",
        value: "IT",
        id: "IT"
    },
    {
        label: "Jamaica",
        value: "JM",
        id: "JM"
    },
    {
        label: "Japan",
        value: "JP",
        id: "JP"
    },
    {
        label: "Jersey",
        value: "JE",
        id: "JE"
    },
    {
        label: "Jordan",
        value: "JO",
        id: "JO"
    },
    {
        label: "Kazakhstan",
        value: "KZ",
        id: "KZ"
    },
    {
        label: "Kenya",
        value: "KE",
        id: "KE"
    },
    {
        label: "Kiribati",
        value: "KI",
        id: "KI"
    },
    {
        label: "Korea (North)",
        value: "KP",
        id: "KP"
    },
    {
        label: "Kuwait",
        value: "KW",
        id: "KW"
    },
    {
        label: "Kyrgyzstan",
        value: "KG",
        id: "KG"
    },
    {
        label: "Lao People's Democratic Republic",
        value: "LA",
        id: "LA"
    },
    {
        label: "Latvia",
        value: "LV",
        id: "LV"
    },
    {
        label: "Lebanon",
        value: "LB",
        id: "LB"
    },
    {
        label: "Lesotho",
        value: "LS",
        id: "LS"
    },
    {
        label: "Liberia",
        value: "LR",
        id: "LR"
    },
    {
        label: "Libya",
        value: "LY",
        id: "LY"
    },
    {
        label: "Liechtenstein",
        value: "LI",
        id: "LI"
    },
    {
        label: "Lithuania",
        value: "LT",
        id: "LT"
    },
    {
        label: "Luxembourg",
        value: "LU",
        id: "LU"
    },
    {
        label: "Macao",
        value: "MO",
        id: "MO"
    },
    {
        label: "Madagascar",
        value: "MG",
        id: "MG"
    },
    {
        label: "Malawi",
        value: "MW",
        id: "MW"
    },
    {
        label: "Malaysia",
        value: "MY",
        id: "MY"
    },
    {
        label: "Maldives",
        value: "MV",
        id: "MV"
    },
    {
        label: "Mali",
        value: "ML",
        id: "ML"
    },
    {
        label: "Malta",
        value: "MT",
        id: "MT"
    },
    {
        label: "Marshall Islands",
        value: "MH",
        id: "MH"
    },
    {
        label: "Martinique",
        value: "MQ",
        id: "MQ"
    },
    {
        label: "Mauritania",
        value: "MR",
        id: "MR"
    },
    {
        label: "Mauritius",
        value: "MU",
        id: "MU"
    },
    {
        label: "Mayotte",
        value: "YT",
        id: "YT"
    },
    {
        label: "Mexico",
        value: "MX",
        id: "MX"
    },
    {
        label: "Micronesia (Federated States of)",
        value: "FM",
        id: "FM"
    },
    {
        label: "Moldova (Republic of)",
        value: "MD",
        id: "MD"
    },
    {
        label: "Monaco",
        value: "MC",
        id: "MC"
    },
    {
        label: "Mongolia",
        value: "MN",
        id: "MN"
    },
    {
        label: "Montenegro",
        value: "ME",
        id: "ME"
    },
    {
        label: "Montserrat",
        value: "MS",
        id: "MS"
    },
    {
        label: "Morocco",
        value: "MA",
        id: "MA"
    },
    {
        label: "Mozambique",
        value: "MZ",
        id: "MZ"
    },
    {
        label: "Myanmar",
        value: "MM",
        id: "MM"
    },
    {
        label: "Namibia",
        value: "NA",
        id: "NA"
    },
    {
        label: "Nauru",
        value: "NR",
        id: "NR"
    },
    {
        label: "Nepal",
        value: "NP",
        id: "NP"
    },
    {
        label: "Netherlands",
        value: "NL",
        id: "NL"
    },
    {
        label: "New Caledonia",
        value: "NC",
        id: "NC"
    },
    {
        label: "New Zealand",
        value: "NZ",
        id: "NZ"
    },
    {
        label: "Nicaragua",
        value: "NI",
        id: "NI"
    },
    {
        label: "Niger",
        value: "NE",
        id: "NE"
    },
    {
        label: "Nigeria",
        value: "NG",
        id: "NG"
    },
    {
        label: "Niue",
        value: "NU",
        id: "NU"
    },
    {
        label: "Norfolk Island",
        value: "NF",
        id: "NF"
    },
    {
        label: "North Macedonia",
        value: "MK",
        id: "MK"
    },
    {
        label: "Northern Mariana Islands",
        value: "MP",
        id: "MP"
    },
    {
        label: "Norway",
        value: "NO",
        id: "NO"
    },
    {
        label: "Oman",
        value: "OM",
        id: "OM"
    },
    {
        label: "Pakistan",
        value: "PK",
        id: "PK"
    },
    {
        label: "Panama",
        value: "PA",
        id: "PA"
    },
    {
        label: "Papua New Guinea",
        value: "PG",
        id: "PG"
    },
    {
        label: "Paraguay",
        value: "PY",
        id: "PY"
    },
    {
        label: "Peru",
        value: "PE",
        id: "PE"
    },
    {
        label: "Philippines",
        value: "PH",
        id: "PH"
    },
    {
        label: "Pitcairn",
        value: "PN",
        id: "PN"
    },
    {
        label: "Poland",
        value: "PL",
        id: "PL"
    },
    {
        label: "Portugal",
        value: "PT",
        id: "PT"
    },
    {
        label: "Puerto Rico",
        value: "PR",
        id: "PR"
    },
    {
        label: "Qatar",
        value: "QA",
        id: "QA"
    },
    {
        label: "Republic of Kosovo",
        value: "XK",
        id: "XK"
    },
    {
        label: "Romania",
        value: "RO",
        id: "RO"
    },
    {
        label: "Russian Federation",
        value: "RU",
        id: "RU"
    },
    {
        label: "Rwanda",
        value: "RW",
        id: "RW"
    },
    {
        label: "R\u05B3union",
        value: "RE",
        id: "RE"
    },
    {
        label: "Saint Barth\u05B3\xa9lemy",
        value: "BL",
        id: "BL"
    },
    {
        label: "Saint Helena, Ascension and Tristan da Cunha",
        value: "SH",
        id: "SH"
    },
    {
        label: "Saint Kitts and Nevis",
        value: "KN",
        id: "KN"
    },
    {
        label: "Saint Lucia",
        value: "LC",
        id: "LC"
    },
    {
        label: "Saint Martin (French part)",
        value: "MF",
        id: "MF"
    },
    {
        label: "Saint Pierre and Miquelon",
        value: "PM",
        id: "PM"
    },
    {
        label: "Saint Vincent and the Grenadines",
        value: "VC",
        id: "VC"
    },
    {
        label: "Samoa",
        value: "WS",
        id: "WS"
    },
    {
        label: "San Marino",
        value: "SM",
        id: "SM"
    },
    {
        label: "Sao Tome and Principe",
        value: "ST",
        id: "ST"
    },
    {
        label: "Saudi Arabia",
        value: "SA",
        id: "SA"
    },
    {
        label: "Senegal",
        value: "SN",
        id: "SN"
    },
    {
        label: "Serbia",
        value: "RS",
        id: "RS"
    },
    {
        label: "Seychelles",
        value: "SC",
        id: "SC"
    },
    {
        label: "Sierra Leone",
        value: "SL",
        id: "SL"
    },
    {
        label: "Singapore",
        value: "SG",
        id: "SG"
    },
    {
        label: "Sint Maarten (Dutch part)",
        value: "SX",
        id: "SX"
    },
    {
        label: "Slovak Republic (Slovakia)",
        value: "SK",
        id: "SK"
    },
    {
        label: "Slovenia",
        value: "SI",
        id: "SI"
    },
    {
        label: "Solomon Islands",
        value: "SB",
        id: "SB"
    },
    {
        label: "Somalia",
        value: "SO",
        id: "SO"
    },
    {
        label: "South Africa",
        value: "ZA",
        id: "ZA"
    },
    {
        label: "South Georgia and the South Sandwich Islands",
        value: "GS",
        id: "GS"
    },
    {
        label: "South Korea",
        value: "KR",
        id: "KR"
    },
    {
        label: "Spain",
        value: "ES",
        id: "ES"
    },
    {
        label: "Sri Lanka",
        value: "LK",
        id: "LK"
    },
    {
        label: "Sudan (North) and Darfur",
        value: "SD",
        id: "SD"
    },
    {
        label: "Sudan (South)",
        value: "SS",
        id: "SS"
    },
    {
        label: "Suriname",
        value: "SR",
        id: "SR"
    },
    {
        label: "Svalbard and Jan Mayen",
        value: "SJ",
        id: "SJ"
    },
    {
        label: "Swaziland",
        value: "SZ",
        id: "SZ"
    },
    {
        label: "Sweden",
        value: "SE",
        id: "SE"
    },
    {
        label: "Switzerland",
        value: "CH",
        id: "CH"
    },
    {
        label: "Syria (Syrian Arab Republic)",
        value: "SY",
        id: "SY"
    },
    {
        label: "Taiwan",
        value: "TW",
        id: "TW"
    },
    {
        label: "Tajikistan",
        value: "TJ",
        id: "TJ"
    },
    {
        label: "Tanzania, United Republic of",
        value: "TZ",
        id: "TZ"
    },
    {
        label: "Thailand",
        value: "TH",
        id: "TH"
    },
    {
        label: "Timor-Leste",
        value: "TL",
        id: "TL"
    },
    {
        label: "Togo",
        value: "TG",
        id: "TG"
    },
    {
        label: "Tokelau",
        value: "TK",
        id: "TK"
    },
    {
        label: "Tonga",
        value: "TO",
        id: "TO"
    },
    {
        label: "Trinidad and Tobago",
        value: "TT",
        id: "TT"
    },
    {
        label: "Tunisia",
        value: "TN",
        id: "TN"
    },
    {
        label: "Turkey",
        value: "TR",
        id: "TR"
    },
    {
        label: "Turkmenistan",
        value: "TM",
        id: "TM"
    },
    {
        label: "Turks and Caicos Islands",
        value: "TC",
        id: "TC"
    },
    {
        label: "Tuvalu",
        value: "TV",
        id: "TV"
    },
    {
        label: "Uganda",
        value: "UG",
        id: "UG"
    },
    {
        label: "Ukraine",
        value: "UA",
        id: "UA"
    },
    {
        label: "United Arab Emirates",
        value: "AE",
        id: "AE"
    },
    {
        label: "United Kingdom",
        value: "GB",
        id: "GB"
    },
    {
        label: "United States Minor Outlying Islands",
        value: "UM",
        id: "UM"
    },
    {
        label: "United States of America (USA)",
        value: "US",
        id: "US"
    },
    {
        label: "Uruguay",
        value: "UY",
        id: "UY"
    },
    {
        label: "Uzbekistan",
        value: "UZ",
        id: "UZ"
    },
    {
        label: "Vanuatu",
        value: "VU",
        id: "VU"
    },
    {
        label: "Vatican",
        value: "VA",
        id: "VA"
    },
    {
        label: "Venezuela (Bolivarian Republic of)",
        value: "VE",
        id: "VE"
    },
    {
        label: "Vietnam",
        value: "VN",
        id: "VN"
    },
    {
        label: "Virgin Islands (British)",
        value: "VG",
        id: "VG"
    },
    {
        label: "Virgin Islands (US)",
        value: "VI",
        id: "VI"
    },
    {
        label: "Wallis and Futuna",
        value: "WF",
        id: "WF"
    },
    {
        label: "Western Sahara",
        value: "EH",
        id: "EH"
    },
    {
        label: "Yemen",
        value: "YE",
        id: "YE"
    },
    {
        label: "Zambia",
        value: "ZM",
        id: "ZM"
    },
    {
        label: "Zimbabwe",
        value: "ZW",
        id: "ZW"
    }
];

});



parcelRegister("ff14C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b18916ed9bb24b63$export$2e2bcd8739ae039; });
class $b18916ed9bb24b63$export$2e2bcd8739ae039 {
    static inject() {
        const hubSpotIFrame = $("iframe.hs-form-iframe").eq(0).contents();
        hubSpotIFrame.find("#custom-form-css").remove();
        const link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = `${MAIN_URL}css/hubspot-style.css`;
        hubSpotIFrame.find("head").append(link);
        link.onload = function() {
            $(".preloader-container").removeClass("show");
        };
    }
}

});

parcelRegister("5yjqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40af3259ee7dd311$export$2e2bcd8739ae039; });

var $7yb8i = parcelRequire("7yb8i");
class $40af3259ee7dd311$export$2e2bcd8739ae039 {
    static inject() {
        $("body").prepend((0, $7yb8i.noScript));
        $("head").append((0, $7yb8i.script));
    }
}

});
parcelRegister("7yb8i", function(module, exports) {

$parcel$export(module.exports, "noScript", function () { return $57f4581cd7dc24bc$export$826435deaaa74704; });
$parcel$export(module.exports, "script", function () { return $57f4581cd7dc24bc$export$bc237d627614fc48; });
const $57f4581cd7dc24bc$export$826435deaaa74704 = `
<!-- Google Tag Manager (noscript) -->
<noscript>
  <iframe 
    src="https://www.googletagmanager.com/ns.html?id=GTM-5K5N62Z" 
    height="0" 
    width="0" 
    style="display:none;
    visibility:hidden"
  ></iframe>
</noscript>
<!-- End Google Tag Manager (noscript) -->
`;
const $57f4581cd7dc24bc$export$bc237d627614fc48 = `
<!-- Google Tag Manager -->
<script>
  (function(w,d,s,l,i){
    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-5K5N62Z');
</script>
<!-- End Google Tag Manager -->
`;

});


parcelRegister("9iny5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c480fc77b7d95e7$export$2e2bcd8739ae039; });

var $3PaSW = parcelRequire("3PaSW");
class $6c480fc77b7d95e7$export$2e2bcd8739ae039 {
    static inject() {
        $("head").append((0, $3PaSW.default));
    }
}

});
parcelRegister("3PaSW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c8e941a07fa2bdc$export$2e2bcd8739ae039; });
var $2c8e941a07fa2bdc$export$2e2bcd8739ae039 = `
<!-- OneTrust Cookies Consent Notice start for docs.rapyd.net -->
<script 
    src="${CONSENT_COOKIE_SCRIPT_SRC}" 
    data-document-language="true" 
    type="text/javascript" 
    charset="UTF-8" 
    data-domain-script="${CONSENT_COOKIE_SCRIPT_DOMAIN_ID}" >
</script>
<script type="text/javascript">
function OptanonWrapper() { }
</script>
<!-- OneTrust Cookies Consent Notice end for docs.rapyd.net -->
`;

});




parcelRequire("bUMk2");
})();
//# sourceMappingURL=main.js.map
